import { Component } from '@angular/core';

@Component({
  selector: 'app-routeoption',
  templateUrl: './routeoption.component.html',
})
export class RouteOptionComponent {}
